import React, {PropTypes as T} from 'react';

const Minus2Icon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Minus Icon"
    viewBox="0 0 13 2"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__minus2 ${className}`}>
    <path d="M0 2V0h13v2z" />
  </svg>
);

Minus2Icon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  Minus2Icon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_minus2.js